<template>
  <div>
    <el-card class="cRight" style="padding: 0;">
      <ul class="rightC">
        <li @click="newClassClick">新增分组</li>
        <li @click="newTemp">新增模板</li>
        <li @click="setDefault" v-if="isTemplate()">设为默认</li>
        <li @click="openBlank" v-if="isTemplate() && isBlank">新页面打开</li>
        <li
          @click="newName"
          v-if="isAdmin() || ((isPersonalTemplate() || isPersonalGroup()) && !isAdmin())"
        >重命名</li>
        <li
          @click="remove"
          v-if="isAdmin() || ((isPersonalTemplate() || isPersonalGroup() || isSystemTemplate()) && !isAdmin())"
        >{{isAdmin()?'删除':'移除'}}</li>
        <li
          @click="amend1"
          v-if="(isAdmin() || ((treeObj.TEMPTYPE != 2 && treeObj.ROLETYPE != 2))) && treeObj.TEMPTYPE != 6"
        >编辑</li>
        <li
          @click="amend2"
          v-if="treeObj.TEMPTYPE != 2 && treeObj.ROLETYPE == 2 && userId =='super'"
        >编辑</li>
      </ul>
    </el-card>
    <el-dialog
      title="模板移动到指定分组"
      :show-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="selectClassDia"
      width="30%"
      append-to-body
    >
      <div>
        <el-tag
          v-for="(item,index) in moveGroupData"
          :key="item.ID"
          @click.native="selectClass(item,index)"
          size="medium"
          type="success"
          :hit="index == isHit ? true : false"
        >{{ item.NAME }}</el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="selectClassEnd">确 定</el-button>
      </span>
    </el-dialog>
    <classAmend ref="classAmend"></classAmend>
    <!-- <TaskSearch ref="TaskSearch"></TaskSearch> -->
    <resultAmend ref="resultAmend"></resultAmend>
  </div>
</template>

<script>
import classAmend from "./classAmend.vue";
// import TaskSearch from "../components/TaskSearch.vue"
import resultAmend from "./resultAmend.vue";

import {
  DelTemplate,
  GetTaskListByTaskIdList,
  HideTemplate,
  SetDefaultTemplate,
  UpdateTemplateOrderIndex,
  UpdateTemplateOrder
} from "@/api/modules/basicData/task";
export default {
  data() {
    return {
      selectClassDia: false,
      moveGroupData: [], //移动分组
      isHit: null,
      childrens: [],
      temClassId: "",
      temClassVal: {}
    };
  },
  props: {
    treeObj: {
      type: Object,
      default: {}
    },
    treeNode: {
      type: Object,
      default: {}
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    isBlank: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    newClassClick() {
      this.$emit("newClassClick");
    },
    newTemp() {
      this.$emit("newTemp");
    },
    isTemplate() {
      //是否是模板
      return this.treeObj.TEMPTYPE == 0 || this.treeObj.TEMPTYPE == 1
        ? true
        : false;
    },
    isAdmin() {
      return this.userId === "super"; //判断是否是super账号
    },
    isDelete() {},
    isSystemGroup() {
      //系统分组
      return this.treeObj.TEMPTYPE == 2 && this.treeObj.TEMPTYPE == 4;
    },
    isSystemTemplate() {
      //系统模板
      return (
        (this.treeObj.TEMPTYPE == 0 || this.treeObj.TEMPTYPE == 1) &&
        this.treeObj.ROLETYPE == 2
      );
    },
    isPersonalGroup() {
      //个人分组
      return this.treeObj.TEMPTYPE == 2 && this.treeObj.ROLETYPE == 0;
    },
    isPersonalTemplate() {
      //个人模板
      return (
        (this.treeObj.TEMPTYPE == 0 || this.treeObj.TEMPTYPE == 1) &&
        this.treeObj.ROLETYPE == 0
      );
    },
    openBlank() {
      console.log("选中的模板值：", this.treeObj);
      let routeUrl = this.$router.resolve({
        path: "/newtask-index",
        query: { query: JSON.stringify(this.treeObj) }
      });
      window.open(routeUrl.href, "_blank");
    },
    setDefault() {
      SetDefaultTemplate(this.treeObj.ID, this.userId,this.treeObj.CATEGORY,0).then(res => {
        if (res == 1) {
          this.$message({
            type: "success",
            message: "设置成功!"
          });
        }
      });
    },
    newName() {
      this.$store.state.template.tagItem = this.treeObj;
      this.$refs.classAmend.dialogVisible = true;
      this.$refs.classAmend.isIcons = true;
      // this.$refs.classAmend.tagItem = this.treeObj;
    },
    remove() {
      let isAdmin = this.userId === "super"; //判断是否是super账号
      if (this.treeObj.TEMPTYPE == 4 && !isAdmin) {
        this.$message("此为系统分组，不可删除");
        return false;
      }
      if (this.treeObj.TEMPTYPE == 2 || this.treeObj.TEMPTYPE == 4) {
        let type = this.treeObj.TEMPTYPE == 4 ? 0 : 2;
        if (this.treeNode.childNodes.length > 0) {
          if (this.temClass.length >= 1) {
            this.$confirm("是否同时移除该分组下的所有模板?", "提示", {
              confirmButtonText: "是",
              cancelButtonText: "否",
              distinguishCancelAndClose: true,
              type: "warning"
            })
              .then(() => {
                let children = this.treeObj.children;
                this.hideTemplate(this.treeObj, type, "");
                // children.forEach(c => {
                //   this.hideTemplate(c, false);
                // });
              })
              .catch(action => {
                if (action === "cancel") {
                  this.childrens = this.treeObj.children;
                  console.log("当前删除的分组：", this.treeObj);
                  console.log("所有的分组", this.temClass);
                  this.moveGroupData = this.temClass.filter(
                    item => item.ID !== this.treeObj.ID
                  );
                  if (this.treeObj.TEMPTYPE == 4) {
                    //系统分组
                    this.moveGroupData = this.moveGroupData.filter(
                      item => item.TEMPTYPE === 4
                    );
                    if (this.moveGroupData.length === 0) {
                      this.$message("没有其他系统分组，不支持移动");
                      return false;
                    }
                  } else {
                    if (this.moveGroupData.length === 0) {
                      this.$message("没有其他分组，不支持移动");
                      return false;
                    }
                  }
                  this.selectClassDia = true;
                }
              });
          } else {
            this.$confirm("是否同时移除最后一个分组?", "提示", {
              confirmButtonText: "是",
              cancelButtonText: "否",
              distinguishCancelAndClose: true,
              type: "warning"
            })
              .then(() => {
                let children = this.treeObj.children;
                this.hideTemplate(this.treeObj, type, "");
                // children.forEach(c => {
                //   this.hideTemplate(c, false);
                // });
              })
              .catch(action => {
                this.$message({
                  message: "放弃删除"
                });
              });
          }
        } else {
          let type = this.treeObj.ROLETYPE === 2 ? 0 : 2;
          this.hideTemplate(this.treeObj, type, "");
        }
      } else {
        let type = this.treeObj.ROLETYPE === 2 ? (this.isAdmin() ? 1 : 6) : 3;
        this.hideTemplate(this.treeObj, type, "");
      }
    },
    selectClass(val, index) {
      console.log(val, "valvalvavla");
      this.temClassId = val.ID;
      this.isHit = index;
      this.temClassVal = val;
    },
    selectClassEnd() {
      //选择分组
      console.log(this.treeDataLeft);
      console.log(this.childrens);
      this.treeDataLeft.forEach(c => {
        if (c.TEMPTYPE == 0 || c.TEMPTYPE == 1) {
        }
      });
      this.hideTemplate(this.treeObj, 2, this.temClassId);
      this.selectClassDia = false;
    },
    hideTemplate(dataObj, type, newTemplateId) {
      // if (type) {
      DelTemplate(dataObj.ID, this.userId, type, newTemplateId).then(res => {
        console.log(res, "移除");
        if (res == 1) {
          this.$store.commit("getAllTemplate");
          this.$message({
            type: "success",
            message: "移除成功!"
          });
        }
      });
    },
    amend1() {
      console.log(this.treeObj, "this.treeObj");
      this.$store.state.template.tagItem = this.treeObj;
      this.$store.commit("redactTemplate", this.treeObj);
      if (this.treeObj.TEMPTYPE == 1) {
        this.$refs.resultAmend.dialogVisible = true;
      } else {
        // if(this.treeObj.CATEGORY == 4){  //计算机特殊处理，其他情况暂时不清楚--smf 20190620
        //   this.$emit("amendSeek", this.treeObj);
        //   return;
        // }
        this.$emit("amendSeek", this.treeObj);
      }
    },
    amend2() {
      console.log(this.treeObj, "this.treeObj");
      this.$store.state.template.tagItem = this.treeObj;
      // this.$root.$emit('amendSearch', this.treeObj);
      this.$store.commit("redactTemplate", this.treeObj);
      // this.$store.commit('createSearchTemp', 1);
      this.$emit("amendSeek", 1);
    }
  },

  components: {
    classAmend,
    // TaskSearch,
    resultAmend
  },
  computed: {
    userId: function() {
      return this.$store.state.task.userId;
    },
    temClass: function() {
      return this.$store.state.template.temClass;
    },
    treeDataLeft: function() {
      return this.$store.state.template.treeDataLeft;
    }
  }
};
</script>

<style scoped>
.rightC {
  /* width: 115px; */
  background-color: #fff;
  cursor: pointer;
}

.cRight .el-card__body {
  padding: 0 !important;
}

.rightC li {
  size: 12px;
  padding: 5px 10px;
}

.rightC li:hover {
  background-color: #ebf9ff;
  color: #5fb1ff;
}
</style>
